
import { Component, Prop, Vue } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import { ValidationProvider } from "vee-validate";
import { Getter } from "vuex-class";
import { Locale } from "@/store";
import { ISolCustomerCurrency } from "@/entities/sol_customer/currency/currency.types";
import HelpAdviseForm from "@/components/orders/HelpAdviseForm.vue";
import { ICountryConfig } from "@/entities";

@Component({
  name: "pickup-form",
  components: {
    Multiselect,
    ValidationProvider,
    HelpAdviseForm,
  },
})
export default class PickupForm extends Vue {
  @Getter("getLocale") locale!: Locale;
  @Getter("getCountryConfig") countryConfig!: ICountryConfig | undefined;
  @Prop({ required: true })
  serviceDate!: Date;
  @Prop({ required: true })
  amount!: number;
  @Prop({ required: true })
  comments!: string;
  @Prop({ required: true, default: [] })
  currencies!: ISolCustomerCurrency[];
  @Prop({ required: true })
  currency!: ISolCustomerCurrency;
  @Prop({ required: false, default: false })
  allowIntervalTime!: boolean;
  @Prop({ required: false })
  initialTime!: string;
  @Prop({ required: false })
  finalTime!: string;
  @Prop({ required: false, default: 2 })
  minimunIntervalTime!: number;
  @Prop({ required: false, default: 1 })
  minimunStartingInterval!: number;
  @Prop({ required: false, default: 8 })
  minimunHour!: number;
  @Prop({ required: false, default: 18 })
  maximunHour!: number;
  @Prop({ required: false, default: false })
  agilePickup!: boolean;
  @Prop({ required: false, default: false })
  isEconoCash!: boolean;

  minDate: Date = new Date();
  startTime: string | undefined = "";
  endTime: string | undefined = "";

  constructor() {
    super();
  }

  mounted(): void {
    const now = new Date();
    this.minDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    this.startTime = this.countryConfig?.Orders.Pickup.ForbiddenNextDay?.StartTime;
    this.endTime = this.countryConfig?.Orders.Pickup.ForbiddenNextDay?.EndTime;
    if (this.startTime && this.endTime) {
      const now = new Date();
      const nowString = now.toDateString();
      const startDate = new Date(nowString + " " + this.startTime);
      const endDate = new Date(nowString + " " + this.endTime);
      if (now >= startDate && now <= endDate) {
        const newDate = new Date(now);
        newDate.setDate(now.getDate() + 2);
        this.$emit("update:serviceDate", newDate);
      }
    }
  }

  get _serviceDate(): Date {
    return this.serviceDate;
  }
  set _serviceDate(value: Date) {
    this.$emit("update:serviceDate", value);
  }
  get _initialTime(): string {
    return this.initialTime;
  }
  set _initialTime(value: string) {
    this.$emit("update:initialTime", value);
  }

  get _finalTime(): string {
    return this.finalTime;
  }
  set _finalTime(value: string) {
    this.$emit("update:finalTime", value);
  }

  get _amount(): number {
    return this.amount;
  }
  set _amount(value: number) {
    this.$emit("update:amount", value);
  }

  get _comments(): string {
    return this.comments;
  }
  set _comments(value: string) {
    this.$emit("update:comments", value);
  }

  get _currency(): ISolCustomerCurrency {
    return this.currency;
  }
  set _currency(value: ISolCustomerCurrency) {
    this.$emit("update:currency", value);
  }
}
